// import React from "react";
// import LetterHead from "./IncoiceLetter";
// export class Welcome extends React.Component {

// //   componentWillReceiveProps(props) {
// //     console.log("will recieve props", props);

// //   }

// const dsdfs = ()=>{

// }

//   render() {
//     let { inVoiceData } = this.props;
//     console.log("inVoiceData", inVoiceData);
//     return <LetterHead Invoice={inVoiceData} className="page"></LetterHead>;
//   }
// }

import React from "react";
import { getSpecificCompany } from "../../helper/utils/api/company";
import { Typography } from "../../core";
import { getContractWithContractId } from "../../helper/utils/api/contract";
import { MixStyle } from "../../styles";
import LetterHead from "./IncoiceLetter";
import styled from "styled-components";
import {
  calculateTotalTaxPayable,
  calculateTotalWithTax,
} from "../../helper/utils/genericAction";

const TotalBillContainer = styled.div`
  max-width: 400px;
  margin: 20px 0px 0px auto;
  .b-b-2 {
    border-bottom: 2px solid #e7ecf4;
  }
  .f-between {
    ${MixStyle.flexBetween};
  }
  > div {
    padding: 15px 0px;
    > span {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #233b67;
    }
  }
  .footer--div {
    ${MixStyle.flexBetween};
    background: #eff5fe;
    border-radius: 0px 0px 14px 14px;
  }
`;

const StyledTable = styled.table`
  border: 1px solid darkblue;
  border-spacing: 0;
  clear: both;
  margin: 2mm 0mm;
  height: 100mm;
  width: 100%;
  th,
  td {
    border-left: 1px solid darkblue;
  }
  th:first-child,
  td:first-child {
    border-left: none;
  }
  .invoice_line th:nth-child(2) {
    width: 60mm;
  }
  th {
    border-bottom: 1px solid darkblue;
  }
  td {
    vertical-align: top;
    font-size: 8pt;
  }
  th {
    text-align: center;
    font-weight: normal;
  }
  .amount {
    text-align: right;
  }
  .invoice_line {
    height: 6mm;
  }
  .invoice_line td,
  .invoice_line th {
    padding: 1mm;
  }
`;

class App extends React.Component {
  // Defining the state
  state = {
    company: "GFG",
    contractDetails: {},
    inVoiceData: {},
    companyDetail: {},
  };

  componentWillReceiveProps(props) {
    let companyId = localStorage.getItem("companyId");
    let { inVoiceData, userId } = props;
    inVoiceData &&
      inVoiceData.contractId &&
      this.getActiveContract(inVoiceData && inVoiceData.contractId);
    if (userId !== undefined) {
      console.log("userId, companyId", userId, companyId);
      this.getActiveCompany(userId, companyId);
    }

    this.setState({ inVoiceData });
  }

  getActiveCompany = async (userId, companyId) => {
    debugger;
    try {
      let {
        data: { result },
      } = await getSpecificCompany({ userId, companyId });

      let newObj = {
        ...result[0],
      };

      this.setState({ companyDetail: newObj });
    } catch (error) {
      console.log("error", error);
    }
  };

  getActiveContract = async (contractId) => {
    debugger;
    try {
      let {
        data: { result },
      } = await getContractWithContractId(contractId);

      let newObj = {
        ...result[0],
      };

      this.setState({ contractDetails: newObj });
    } catch (error) {
      console.log("error", error);
    }
  };

  render() {
    console.log("this.state", this.state);
    return (
      <LetterHead state={this.state} className="page">
        <div>
          <StyledTable>
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tr className="invoice_line">
              <th>Quantity</th>
              <th>Description</th>
              <th>Price</th>
              <th>Price without sale tax</th>
              <th>Rate of sale tax</th>
              <th>sales tax payable Rs</th>
              <th>Value include sales tax</th>
            </tr>
            {this.state &&
            this.state.inVoiceData &&
            this.state.inVoiceData.clothReturnVariations &&
            this.state.inVoiceData.clothReturnVariations.length > 0 ? (
              // <tr className="invoice_line">
              //   <td>Quantity</td>
              //   <td>Description</td>
              //   <td>Price</td>
              //   <td>Price without sale tax</td>
              //   <td>Rate of sale tax</td>
              //   <td>sales tax payable Rs</td>
              //   <td>Value include sales tax</td>
              // </tr>
              this.state.inVoiceData.clothReturnVariations.map((item, idx) => (
                <tr className="invoice_line">
                  <td>{item && item.quantity}</td>
                  <td>Description</td>
                  <td>{item && item.rate}</td>
                  <td>{item.quantity * item.rate}</td>
                  <td>
                    {this.state &&
                      this.state.inVoiceData &&
                      this.state.inVoiceData.tax}
                  </td>
                  <td>
                    {calculateTotalTaxPayable(
                      item.quantity,
                      item.rate,
                      this.state.inVoiceData.tax
                    )}
                  </td>
                  <td>
                    {calculateTotalWithTax(
                      item.quantity,
                      item.rate,
                      this.state.inVoiceData.tax
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr className="invoice_line">
                {console.log("this.state.netPass", this.state.inVoiceData)}
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.netPass}
                </td>
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.invoiceNote}
                </td>
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.fabricRatePerMeter}

                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.conversionRate}
                </td>
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.invoiceTotalExcludeTax}
                </td>
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.tax}
                </td>
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.totalTaxRate}
                </td>
                <td>
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.invoiceTotalIncludeTax}
                </td>
              </tr>
            )}
            {/* <tr className="invoice_line">
              <td>Quantity</td>
              <td>Description</td>
              <td>Price</td>
              <td>Price without sale tax</td>
              <td>Rate of sale tax</td>
              <td>sales tax payable Rs</td>
              <td>Value include sales tax</td>
            </tr> */}
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </StyledTable>
          <TotalBillContainer>
            <div className="f-between b-b-2">
              <Typography as="h6" noMargin color="#233B67" weight="500">
                Sub Total Exclude Tax
              </Typography>
              <Typography as="h6" noMargin color="#404E67" weight="500">
                Rs&nbsp;
                {this.state &&
                  this.state.inVoiceData &&
                  this.state.inVoiceData.invoiceTotalExcludeTax &&
                  this.state.inVoiceData.invoiceTotalExcludeTax}
              </Typography>
            </div>

            <div className="f-between b-b-2">
              <span>Total Tax</span>
              <span>
                Rs&nbsp;
                {this.state &&
                  this.state.inVoiceData &&
                  this.state.inVoiceData.totalTaxRate &&
                  this.state.inVoiceData.totalTaxRate}
              </span>
            </div>

            <div className="f-between b-b-2">
              <Typography as="h6" noMargin color="#404E67" weight="500">
                Grand Total Include Tax
              </Typography>
              <Typography as="h6" noMargin color="#404E67" weight="500">
                Rs&nbsp;
                <span className="themed--color_pink">
                  {this.state &&
                    this.state.inVoiceData &&
                    this.state.inVoiceData.invoiceTotalIncludeTax &&
                    this.state.inVoiceData.invoiceTotalIncludeTax}
                </span>
              </Typography>
            </div>
          </TotalBillContainer>
        </div>
      </LetterHead>
    );
  }
}

export default App;
